import { PayloadAction } from "@reduxjs/toolkit";
import { AllState } from "../models/AllState";
import { ServerError } from "../../../../common/models/ServerError";

const setServerError = (state: AllState, action: PayloadAction<ServerError>) => {
    const serverError = action.payload;
    state.serverError = serverError;
}

export default setServerError;